import * as Immutable from 'immutable'
import * as React from 'react'
import {
  Action,
  IOWidget,
  mk_widget,
  unloadedAsyncState,
  Fun,
  div,
  string,
  mk_pair,
  none,
  loadingAsyncState,
  some,
  Option,
  Widget,
  AsyncState,
  async
} from 'widgets-for-react'
import { Id, CMSState, ImageSize, Url } from '../../../../cms/blocks/types.gen'
import { ExtraImages } from '../../../utils/extra_images.mod'
import {
  maps,
  maps_no_stateful
} from '../../../../map/maps'
import {
  mocked_up_categories,
  center_amersfoort,
  example_plus,
  sample_MapStyling,
  mocked_up_tile_provides,
  apply_layer,
  provider,
  generateMapEntity,
  params_to_string,
  setQueryStringParameter,
  update_params,
  example_handDownPoint,
  example_pointerIcon,
  MapListItem,
  getDistance,
  get_lang_from_url
} from '../../../../map/maps_utils'
import { isCustomBlockData, CustomBlockData, mapBlockData } from '../types.mod'
import {
  MapEntity,
  MapsState,
  CenterMarker,
  SearchResult,
  OpenStreetMapProviderResultRaw,
  CategoriesList,
  SimpleList,
  MapSearchResult,
  PresentationState,
  PeliasSearchResult
} from '../../../../map/maps_types'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { withRouter } from 'react-router-dom'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { LatLngLiteral } from 'leaflet'
import { t } from 'i18next'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { remove } from 'diacritics'

export type AddressType = {
  BillingCity: string
  BillingLatitude: number
  BillingLongitude: number
  BillingPostalCode: string
  BillingStreet: string
  Name: string
  Phone: string
  Website: string
}

export const map_address_to_map_entity: Fun<WordPress.LocationResponse, MapEntity> = location => {
  const address = [location.acf.street, location.acf.number, location.acf.number_addition].join(' ')
  return {
    position: { lat: parseFloat(location.acf.latitude), lng: parseFloat(location.acf.longitude) },
    info_when_on_list: (e, presentation_mode: PresentationState) => (
      <MapListItem presentationMode={presentation_mode.value.kind} {...location.acf} />
    ),
    info_when_on_map: e => (
      <div className='map-modal'>
        <h3 className='map-modal__title typo--s'>{location.title.rendered}</h3>

        <div className='map-modal__address typo--2xs'>
          {location.acf.offices ? location.acf.offices.length : 0} locations
        </div>
        <a className='list__link link typo--2xs' href={get_lang_from_url(lang => `/${lang == '' ? 'country' : 'land'}/${remove(location.acf.country)}`)}>
          View contact information
        </a>
        {/* {`x:${p.lng}y:${p.lat}`} */}
      </div>
    ),
    show_info_on_map: 'on_click',
    icon: e => (e.selection_status != 'none' ? example_handDownPoint : example_pointerIcon),
    selection_status: 'none'
  } as MapEntity
}

export let get_addresses = (): AsyncState<Immutable.List<WordPress.LocationResponse>> => {
  return loadingAsyncState(async () => {
    const response = await fetch(get_lang_from_url(l => '/wp-json/wp/v2/locations?page=1&per_page=100'))
    const result = (await response.json()) as WordPress.LocationResponse[]
    return {
      kind: 'result',
      status: 200,
      value: Immutable.List(result).sort((a, b) => a.acf.country < b.acf.country ? -1 : 1).toList()
    }
  })
}

export type mapBlockProps = {
  block_index: number
  state: MapsState
  addresses: AsyncState<Immutable.List<WordPress.LocationResponse>>
}

export type mapBlockStyle = Partial<{}>

export function mapBlock(
  props: mapBlockProps,
  options?: { style: mapBlockStyle; key?: string }
): (
  s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
) => IOWidget<
  PublicSiteState,
  Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>
> {
  return (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => (
    public_state: PublicSiteState
  ) =>
    mk_widget({
      run: set_state => {
        let widget = maps_no_stateful(props.state).run(future_state => {
          let new_state = future_state(props.state)
          set_state(s => {
            let currentBlock = s.blocks.get(props.block_index) as any

            if (currentBlock.kind === 'mapBlock') {
              currentBlock = {
                ...currentBlock,
                value: mk_pair(
                  {
                    ...currentBlock.value.fst,
                    state: { ...new_state, route_state: 'none' }
                  },
                  currentBlock.value.snd
                )
              }
            }

            // let route_params1: { param: string; value: string }[][] = undefined
            // if (s.custom_page_data.v.kind == 'r') {
            //   route_params1 = s.custom_page_data.v.v.extra_params
            //   if (new_state.route_state == 'update') {
            //     route_params1 = s.custom_page_data.v.v.extra_params || [
            //       [{ param: 'kind', value: 'map' }]
            //     ]
            //     route_params1 = update_params(new_state, route_params1)
            //     let route_params1_string = params_to_string(route_params1)
            //     setQueryStringParameter('queryParams', route_params1_string)
            //   }
            // }

            return {
              ...s,
              blocks: s.blocks.set(props.block_index, currentBlock),
              custom_page_data:
                s.custom_page_data.v.kind == 'l'
                  ? none<PublicSite_CustomPageData>()
                  : some<PublicSite_CustomPageData>({
                      ...s.custom_page_data.v.v,
                      extra_params: null
                    })
            }
          })
        })
        return (
          <>
            {async<Immutable.List<WordPress.LocationResponse>>()(get_addresses()).run(a => {
              set_state(s => {
                let currentBlock = s.blocks.get(props.block_index) as mapBlockData

                if (currentBlock.kind === 'mapBlock') {
                  let new_addresses = a(currentBlock.value.fst.addresses)
                  let entity = currentBlock.value.fst.state

                  currentBlock = {
                    ...currentBlock,
                    value: mk_pair(
                      {
                        ...currentBlock.value.fst,
                        addresses: new_addresses,
                        state: {
                          ...entity,
                          data_to_display: {
                            ...entity.data_to_display,
                            entities:
                              new_addresses.kind == 'loaded'
                                ? new_addresses.value
                                : (entity.data_to_display as any).entities
                          },
                          optional_bounds:
                            new_addresses.kind == 'loaded'
                              ? new_addresses.value
                                  .map(l => {
                                    const p = map_address_to_map_entity(l)
                                    return [p.position.lat, p.position.lng] as [number, number]
                                  })
                                  .filter(
                                    p =>
                                      getDistance(
                                        { lat: p[0], lng: p[1] },
                                        entity.center_marker.position
                                      ) < 3000
                                  )
                                  .toArray()
                              : entity.optional_bounds,
                          search_status:
                            new_addresses.kind == 'loaded' &&
                            entity.search_status.kind == 'input' &&
                            entity.search_status.value != undefined &&
                            entity.search_status.value != ''
                              ? {
                                  kind: 'search',
                                  value: entity.search_status.value,
                                  async: search(entity.search_status.value, null, true)
                                }
                              : entity.search_status
                        }
                      },
                      currentBlock.value.snd
                    )
                  }
                }

                return { ...s, blocks: s.blocks.set(props.block_index, currentBlock) }
              })
            })}
            {widget}
          </>
        )
      }
    })
}
let search = (input: string, current_state: MapsState, called_from_route?: boolean) => {
  return loadingAsyncState(async () => {
    // let new_input = ''
    // let maybe_postcode = 0
    // for (let i = 0; i < input.length; i++) {
    //   const current_c = input[i]
    //   //bad, the search cannot see that 2901je is the same as 2901 je. this means that we need to remove that space
    //   if (current_c != ' ' && !isNaN(+current_c)) {
    //     maybe_postcode += 1
    //     new_input += current_c
    //   } else {
    //     if (maybe_postcode == 4 && current_c == ' ') {
    //       //we skip
    //     } else {
    //       new_input += current_c
    //     }
    //     maybe_postcode = 0
    //   }
    // }

    // let results = await provider.search({ query: new_input })

    let response = await fetch(
      `/pelias/search/?text=${input}&layers=address,postalcode,locality,country`
    )
    let results = await response.json()
    //results will contain the lat/long associated to the input search and an optional new set of data
    let new_res: MapSearchResult = {
      centers: results as PeliasSearchResult,
      new_data: none<CategoriesList | SimpleList>()
    }
    return { kind: 'result', status: 200, value: new_res }
  })
}
export let frieslandcampina_corporate_map = (
  route_params?: { param: string; value: string }[][],
  city?: string
): MapsState => {
  return {
    route_state: 'none',
    center_marker: {
      position: center_amersfoort,
      icon: (entity_state: CenterMarker) => example_plus
    },
    presentation_mode: {
      value: { kind: 'show map' },
      default_list_range: 370000000,
      delta_increase_range_value: 100000
    },
    header: (state: MapsState) => {
      return mk_widget({
        run: set_state => {
          return (
            <div className={`${state.styling.root__map__actions} `}>
              <button
                className={`${state.styling.root__switch}${
                  state.presentation_mode.value.kind == 'show list' ? 'list' : 'map'
                }`}
                onClick={() =>
                  set_state(s => ({
                    ...s,
                    route_state: 'update',
                    map: 'none',
                    presentation_mode: {
                      ...s.presentation_mode,
                      value:
                        s.presentation_mode.value.kind == 'show map'
                          ? {
                              kind: 'show list',
                              current_range: s.presentation_mode.default_list_range
                            }
                          : {
                              kind: 'show map'
                            }
                    }
                  }))
                }
              >
                <span className={state.styling.root__switch__item}>{t('blocks.mapBlock.map')}</span>
                <span className={state.styling.root__switch__item}>
                  {t('blocks.mapBlock.list')}
                </span>
              </button>
              {/*
                  <button disabled={state.presentation_mode.value.kind == "show list"}
                          onClick={() => set_state(s => ({...s,
                          route_state:"update",
                          map:"none",
                          presentation_mode:{...s.presentation_mode, value:{kind:"show list", current_range:s.presentation_mode.default_list_range}}}))}>List</button>
                  <button disabled={state.presentation_mode.value.kind == "show map"}
                          onClick={() => set_state(s => ({...s,
                          route_state:"update",
                          presentation_mode:{...s.presentation_mode, value:{kind:"show map"}}}))}>Map</button> */}
            </div>
          )
        }
      })
    },
    last_center_on_map: 'none',
    default_center: center_amersfoort,
    internal_cluster_key: 0,
    last_event: 'none',
    list_title: 'Deze locaties bevinden zich bij u in de buurt',
    map: 'none',
    max_zoom: 6,
    styling: sample_MapStyling,
    search_label: 'Vind een locatie in de buurt van:',
    search_status: { kind: 'input', value: city ? city : '' },
    map_tile_provider: {
      default_tile_provider: 'CartoDB.Positron',
      list_tile_provides: Immutable.List([
        {
          name: 'CartoDB.Positron',
          apply: (map: L.Map) => {
            apply_layer('CartoDB.Positron', map)
          }
        }
      ])
    },
    default_search_function: search,
    last_searched_center: 'none',
    data_to_display: {
      kind: 'simple_list',
      entities: Immutable.List() //generateMapEntity(center_rotterdam, 2000, 50)
    },
    current_zoom: 2
  }
}

//http://localhost:5000/?queryParams=kind$map!city$rotterdam!view$list!zoom$13&slug=sample-page
